import React from "react"
import { Typography } from "antd"
import styled from "@emotion/styled"
import { SampleCourseVideoForm } from "./SampleCourseVideoForm"
import Link from "next/link"

export const SampleCourseVideo = ({ courseName, courseSlug, courseRegistrationUrl, sampleCourseVideoUrl }: Props) => {
  return (
    <SampleCourseVideoWrapper>
      <Title level={2}>Ukázková hodina</Title>

      <Typography.Paragraph>
        Stále váháte? Vyzkoušejte ukázkovou hodinu našeho IT kroužku a uvidíte, jak může váš potomek rozvíjet své digitální dovednosti! Je to skvělá příležitost
        pozorovat vaše dítě v akci, jak tvoří a objevuje nové technologie. Po zadání vašeho e-mailu vám pošleme odkaz na video ukázkové hodiny, které si můžete
        kdykoliv a odkudkoliv pohodlně přehrát. Nezmeškejte tuto šanci podpořit kreativitu a kritické myšlení vašeho dítěte v bezpečném a podnětném prostředí.
        Po zhlédnutí videa budeme rádi, když se zaregistrujete do našeho kurzu a umožníte tak vašemu dítěti plně se rozvinout v oblasti digitálních technologií.{" "}
        <span className="description">
          Odesláním souhlasím se{" "}
          <Link href="/zpracovani-osobnich-udaju" target="_blank">
            zpracování osobních údajů
          </Link>
          .
        </span>
      </Typography.Paragraph>

      <SampleCourseVideoForm
        courseName={courseName}
        courseSlug={courseSlug}
        courseRegistrationUrl={courseRegistrationUrl}
        sampleCourseVideoUrl={sampleCourseVideoUrl}
      />
    </SampleCourseVideoWrapper>
  )
}

const SampleCourseVideoWrapper = styled.div``

const Title = styled(Typography.Title)`
  margin-top: 1.2em;
`

interface Props {
  courseName: string
  courseSlug: string
  courseRegistrationUrl: string
  sampleCourseVideoUrl: string
}
